import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.CompareWorkspace,
  title: 'Compare Workspace',
  category: ComponentCategory.General,
  droppable: true,
};
